<template>
    <v-dialog v-model="showDialog" max-width="500" scrollable>
        <v-card style="overflow-y: auto">
            <v-card-title class="d-flex error--text">
                <v-icon color="error" class="mr-1">mdi-sticker-alert-outline</v-icon>
                {{$translate('Cancellation and Refund Policy')}}
                <v-btn icon @click="showDialog = false" class="ml-auto"><v-icon>mdi-close</v-icon></v-btn>
            </v-card-title>

            <v-card-text>
                <template v-if="cancelRules && cancelRules.canCancel">
                    {{$translate('Cancellation is allowed until {0}').format(lastCancelTime)}}

                    <ul v-if="cancelRules.rules && cancelRules.rules.length">
                        <li>
                            {{$translate('Until and including {0}, cancellation is free of charge').format(getRuleTimeText(cancelRules.rules[0]))}}
                        </li>
                        <li v-for="(rule,index) in cancelRules.rules" :key="index">
                            {{getRuleText(rule)}}
                        </li>
                    </ul>
                </template>
                <template v-else>
                    {{$translate('Cancellation not allowed')}}
                </template>

                <v-card-actions v-if="showAcceptButton">
                    <v-btn @click="showDialog = false; $emit('accepted')" class="zoezi-button-thin" block color="primary">{{$translate('I accept the terms')}}</v-btn>
                </v-card-actions>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import { RelativeTime, formatPrice } from '../util';
export default {
    name: 'zoezi-cancel-rules-dialog',

    props: {
        value: {
            type: Boolean
        },
        cancelRules: {
            type: Object
        },
        showAcceptButton: {
            type: Boolean,
            default: false
        }
    },

    watch: {
        value: {
            immediate: true,
            handler(value) {
                this.showDialog = value;
            }
        },
        showDialog(value) {
            this.$emit('input', value);
        }
    },

    computed: {
        lastCancelTime() {
            if (!this.cancelRules || !this.cancelRules.lastCancelTime) {
                return null;
            }
            let lct = this.cancelRules.lastCancelTime;

            if (lct instanceof RelativeTime) {
                return lct.string;
            } else if (lct instanceof Date) {
                return lct.dateTime();
            } else {
                return new RelativeTime(lct).string;
            }
        }
    },

    data: () => ({
        showDialog: false
    }),

    methods: {
        getRuleTimeText(rule) {
            return new RelativeTime(rule.time).string
        },
        getRuleText(rule) {
            let time = new RelativeTime(rule.time);
            let cost = '';
            if (rule.cost_percent) {
                cost += rule.cost_percent + ' % ' + window.$translate('of the course price');
            }
            if (rule.cost_fixed) {
                if (cost) {
                    cost += ' + ';
                }
                cost += formatPrice(rule.cost_fixed);
            } else {
                if (!cost) {
                    cost = formatPrice(0);
                }
            }

            cost = window.$translate('for') + ' ' + cost;

            if (rule.cost_percent == 100 && !rule.cost_fixed) {
                cost = ', ' + window.$translate('but without any refund at all');
            }

            return window.$translate(time.relative.id == 'beforestart' ? 'Is it less than' : 'Is it more than') + ' ' + time.string + ' ' + window.$translate('cancellation is allowed') + ' ' + cost;
        }
    }
}
</script>
